import React from "react";

import { Eyebrow, Title } from "../components/CommonComponents";

import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const advisors = [
  { name: "Mr. Jitendra Nahar", designation: "Founder Trustee", organization: "Anjaneya University" },
  { name: "Mr. Rajan Chopra", designation: "Chancellor - Mahatma Gandhi University", organization: "MD - Excel Books" },
  { name: "Mr. Rahul Tiwari", designation: "Secretary - Shree Rahul Education Society", organization: "Trustee - Rahul Group of Schools" },
  { name: "Dr. A.L Agrawal-Chairman", designation: "Founder - World Education Mission,", organization: "President - Arunachal University of Studies" },
  { name: "Mr. Vivek Mohile", designation: "General Manager - Laticrete International,", organization: "Saudi Arabia." },
  { name: "Mr. Sameep Shastri", designation: "Vice Chairman - BRICS", organization: "Chamber of Commerce & Industry" },
  { name: "Adv. D.G. Naik", designation: "Senior Counsel - High Court, Mumbai", organization: "" },
  { name: "Mr. Abhishek Agarwal", designation: "Founder - Aanjaneya University", organization: "" },
  { name: "Mrs. Sabitha Natraj", designation: "General Manager - Indian Oil Corporation", organization: "" },
  { name: "Dr. A.K Bhatt", designation: "Regional- Director NIOS Govt. of India", organization: "" },
  { name: "Dr. P.V Pradhan", designation: "Executive Director - Thakur Education Trust", organization: "" },
  { name: "Mr. Dinesh Gosai", designation: "Trainer and Mentor - Meta Corporate NLP Coach", organization: "" },
  { name: "Mr. Shakti Swamy", designation: "Consultant and Coach", organization: "" },
  { name: "Mr. Dinesh Israni", designation: "CEO - Naman Angels Network", organization: "" },
  { name: "Dr. Munir Sayyad", designation: "General Manager & Head of Reliance JIO", organization: "quality Assurance Lab, Mumbai." },
  { name: "Mr. Sudeep Saha", designation: "Managing Director - Avant Group", organization: "IIM-A, CFA (USA)" },
  { name: "Mr. Yeshwant Raj Parasmal", designation: "Managing Director - Strategum Eduserve", organization: "Private limited" },
  { name: "Dr. Rajesh Bansode", designation: "IQAC Coordinator & MR,", organization: "Thakur College of Engineering & Technology" },
  { name: "Adv. SK Farhan", designation: "Senior Counsel - District Court, Raipur", organization: "" },
  { name: "Adv. Syed Zeeshan", designation: "Counsel - High Court, Bilaspur", organization: "" },
  { name: "Dr. Ravish Singh", designation: "Director - Thakur R Ramnarayan College of Arts & Commerce", organization: "" },
  { name: "Mr. Lohith Suvarna", designation: "Director - Acadment Education LLP", organization: "" },
];

const getInitials = (name) => name.replace(/(Mr\.|Mrs\.|Dr\.|Adv\.)/g, "").trim().split(" ").filter(Boolean).slice(0, 2).map((part) => part[0]).join("").toUpperCase();

export default function BoardOfAdvisors() {
  return (
    <>
      <MetaInfo param="" id="about" />
      <Header school="common" />

      <main className="overflow-hidden bg-white text-[#132337]">

        <section className="relative isolate min-h-[760px] overflow-hidden bg-[#071A2F] text-white">
          <div className="absolute inset-0 -z-30 bg-[#071A2F]" />
          <div className="absolute inset-0 -z-20 bg-[radial-gradient(circle_at_82%_16%,rgba(213,173,87,0.18),transparent_26%),radial-gradient(circle_at_14%_84%,rgba(139,30,63,0.28),transparent_32%)]" />
          <div className="absolute right-0 top-0 -z-10 h-full w-[42%] border-l border-white/10 bg-white/[0.025]" />
          <div className="absolute right-[5%] top-[16%] -z-10 hidden h-[420px] w-[420px] rounded-full border border-[#D5AD57]/15 lg:block" />
          <div className="absolute right-[10%] top-[23%] -z-10 hidden h-[300px] w-[300px] rounded-full border border-white/10 lg:block" />

          <div className="mx-auto grid min-h-[760px] w-[min(1380px,calc(100%-48px))] items-end gap-14 pb-20 max-sm:w-[calc(100%-28px)] lg:grid-cols-[1fr_420px] lg:items-center lg:pb-0">
            <div className="max-w-[900px]">
              <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                <span className="h-px w-12 bg-current" />
                Board of Advisors
              </div>

              <h1 className="mt-7 max-w-[920px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,6.8vw,96px)] font-normal leading-[0.94] tracking-[-0.05em]">
                Experience that helps
                <span className="block text-[#D5AD57]">shape perspective.</span>
              </h1>
            </div>

            <div className="relative hidden min-h-[430px] lg:block">
              <div className="absolute bottom-10 right-0 w-full border border-white/12 bg-white/[0.035] p-8 backdrop-blur-sm">
                <div className="flex items-end justify-between border-b border-white/10 pb-7">
                  <span className="text-xs font-bold uppercase tracking-[0.18em] text-[#D5AD57]">Advisory Council</span>
                  <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[72px] font-normal leading-none text-white">{String(advisors.length).padStart(2, "0")}</strong>
                </div>

                <div className="grid grid-cols-2 divide-x divide-white/10 pt-7">
                  <div className="pr-6">
                    <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-white/35">Board</span>
                    <p className="mt-2 font-['Libre_Caslon_Display',Georgia,serif] text-[24px] leading-tight text-white">Advisors</p>
                  </div>

                  <div className="pl-6">
                    <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-white/35">University</span>
                    <p className="mt-2 font-['Libre_Caslon_Display',Georgia,serif] text-[24px] leading-tight text-white">ISBM University</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <div className="grid gap-10 border-b border-[#071A2F]/15 pb-10 lg:grid-cols-[1fr_420px] lg:items-end">
              <div>
                <Eyebrow>Board of Advisors</Eyebrow>
                <Title before="Meet Our" highlight="Board of Advisors" after="" position="middle" theme="burgundy" />
              </div>

              <div className="flex items-end justify-between gap-8 lg:justify-end">
                <span className="text-xs font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">Members</span>
                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[68px] font-normal leading-none text-[#8B1E3F]">{String(advisors.length).padStart(2, "0")}</strong>
              </div>
            </div>

            <div className="mt-12 grid gap-6 lg:grid-cols-2">
              {advisors.map((advisor, index) => (
                <article key={`${advisor.name}-${index}`} className="group relative overflow-hidden border border-[#071A2F]/10 bg-white transition duration-300 hover:-translate-y-1 hover:border-[#D5AD57]/70 hover:shadow-[0_20px_55px_rgba(7,26,47,0.08)]">
                  <div className="grid min-h-[210px] grid-cols-[110px_1fr] sm:grid-cols-[140px_1fr]">
                    <div className="relative flex items-center justify-center overflow-hidden bg-[#071A2F]">
                      <span className="absolute left-4 top-4 text-[10px] font-bold tracking-[0.16em] text-[#D5AD57]">{String(index + 1).padStart(2, "0")}</span>
                      <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[42px] font-normal text-white/85 sm:text-[48px]">{getInitials(advisor.name)}</strong>
                      <span className="absolute bottom-0 left-0 h-[3px] w-full bg-[#D5AD57]" />
                    </div>

                    <div className="flex flex-col justify-center p-7 sm:p-8">
                      <h2 className="font-['Libre_Caslon_Display',Georgia,serif] text-[29px] font-normal leading-[1.15] text-[#071A2F]">{advisor.name}</h2>
                      <p className="mt-5 text-sm font-semibold leading-6 text-[#8B1E3F]">{advisor.designation}</p>

                      {advisor.organization && (
                        <p className="mt-2 text-sm leading-6 text-[#132337]/55">{advisor.organization}</p>
                      )}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
}
